<template>
    <section class="ad-sec1">
        <div v-if="width > 1024" class="ad-sec1-bg"></div>
        <div class="ad-sec1-container" :class="{ rowReverse }">
            <div class="ad-sec1-img" :class="imageAnimation">
                <img :src="imageSrc" alt="" />
            </div>
            <div class="ad-sec1-txt">
                <h1>{{ title }}</h1>
                <p v-html="text"></p>
                <a :href="isLoggedIn ? campaignPath : loginPath" class="btn btn--primary">
                    <span> شروع تبلیغ </span>
                    <img src="../assets/images/login-bold-duotone.svg" class="icon" />
                </a>
            </div>
        </div>
    </section>
</template>

<script>
import { ref, inject } from 'vue';
export default {
    name: "AdSection1",
    props: {
        imageSrc: {
          type: String,
          required: true
        },
        title: {
          type: String,
          required: true
        },
        text: {
          type: String,
          required: true
        },
        rowReverse: {
          type: Boolean,
          default: false
        },
        imageAnimation: {
          type: String,
          default: 'fade-right'
        }
      },
    setup() {
        const width = inject('viewportWidth');
        const isLoggedIn = inject('isLoggedIn', ref(false));
        const campaignPath = inject('campaignPath');
        const loginPath = inject('loginPath');

        return {
            width,
            isLoggedIn,
            campaignPath,
            loginPath
        }

    }
};
</script>

<style scoped>
.rowReverse {
    flex-direction: row-reverse;
    overflow-x: hidden;
}

.fade-right {
    animation: fadeRight 2s ease-out forwards;
}

.fade-left {
    animation: fadeLeft 2s ease-out forwards;
}

.ad-sec1 {
    position: relative;
}

.ad-sec1,
.ad-sec1-img img {
    width: 100%;
}

.ad-sec1-bg {
    background:
        radial-gradient(circle at top left, rgb(213 68 116 / 18%) 0%, rgb(255 171 184 / 0%) 20%, #00000000 40%),
        radial-gradient(circle at top right, rgb(255 64 129 / 15%) 0%, rgb(213 68 116 / 0%) 20%, transparent 40%),
        linear-gradient(white 50%, white 100%);
    height: 554px;
    margin-top: -118px;
}

.ad-sec1-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 5.23%;
    padding-top: 14.931%;
    margin-inline: 12.37%;
    width: calc(100% - 24.74%);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    //overflow: hidden;
}

.ad-sec1-img {
    aspect-ratio: 543 / 333;
    width: 51%;
    max-width: 543px;
    max-height: 333px;
    flex-shrink: 0;
}

.ad-sec1-img img {
    height: auto;
    object-fit: contain;
}

.ad-sec1-txt {
    flex-grow: 1;
}

.ad-sec1-txt h1,
.ad-sec1-txt p {
    margin-bottom: 5%;
}

.ad-sec1-txt h1 {
    font-family: IRANYekan-Bold;
    font-size: 30px;
    line-height: 42px;
}

.ad-sec1-txt h1,
.ad-sec1-txt p {
    text-align: justify;
    animation: fadeIn 3s ease-out forwards;
}

.ad-sec1-txt p {
    line-height: 28px;
}

.ad-sec1-txt a {
    width: fit-content;
}

@media screen and (min-width:1441px) {
    .ad-sec1-container {
        width: 1145px;
        padding-top: 215px;
        margin-inline: auto;
    }
}

@media screen and (max-width:1024px) {
    .ad-sec1-container {
        position: unset;
        padding-block: 3.931%;
        margin-inline: 5.556%;
        width: calc(100% - 11.112%);
    }

    .ad-sec1-img {
         width: 47%;
    }

    .ad-sec1-txt h1 {
        font-size: 24px;
        line-height: 34px;
    }

    .ad-sec1-txt p {
        line-height: 26px;
    }
}

@media screen and (max-width:768px) {
    .ad-sec1-container {
        flex-direction: column;
        margin-inline: 9.03%;
        width: calc(100% - 18.06%);
        gap: 24px;
    }

    .ad-sec1-img {
        width: 282px;
        height: 174px;
    }

    .ad-sec1-txt h1 {
        margin-bottom: 7px;
    }

    .ad-sec1-txt p {
        margin-bottom: 12px;
    }

    .ad-sec1-txt a {
        margin-inline: auto;
    }
}

@media screen and (max-width:375px) {
    .ad-sec1-txt h1 {
        font-size: 20px;
    }

    .ad-sec1-txt p {
        font-size: 16px;
    }
}

</style>

